module.exports = "./img/39c6552f32adcbdf651719dc093aae4c.png";